import React, { useMemo } from 'react'

import { Paragraph, Switch, Select } from 'src/components'
import { toMoney } from 'src/utils/utilities'
import { getTotalByItems } from 'src/components/organims/itemsTaxOperations/TaxOperationFunctions'
import { TaxOperationTypeEnum } from 'src/components/organims/itemsTaxOperations/TaxOperationTypeEnum'

interface IItemTaxOperationProps {
  type: TaxOperationTypeEnum
  item: IItemTaxOperation
  taxes: Tax[]
  onChange: (item: IItemTaxOperation) => void
}

export const ItemTaxOperation = ({
  type,
  item,
  onChange,
  taxes,
}: IItemTaxOperationProps) => {
  const retentionOptions = useMemo(() => {
    return [{ value: null, label: 'Sin retención' }, ...taxes]
  }, [taxes])

  const { name, code } = item.metadata.product
  const { quantity, taxException } = item

  const total = getTotalByItems([item])

  const onChangeTaxException = () => {
    onChange({ ...item, taxException: !taxException })
  }

  const onChangeTaxRetention = (taxRetention: ISelectNumber) => {
    onChange({ ...item, taxRetention })
  }

  return (
    <div className={'b-item column'}>
      <div className={'d-flex'}>
        <div style={{ width: '20%' }}>
          {type === TaxOperationTypeEnum.EXEMPT ? (
            <Switch
              checked={item.taxException}
              changeValue={() => onChangeTaxException()}
            />
          ) : (
            <Select
              withoutLabel
              options={retentionOptions}
              value={item.taxRetention}
              onChange={onChangeTaxRetention}
            />
          )}
        </div>
        <div style={{ width: '40%' }} className={'column'}>
          <Paragraph>{name}</Paragraph>
          <Paragraph dim>{code}</Paragraph>
        </div>
        <div style={{ width: '40%' }} className={'right'}>
          <Paragraph>Total: {toMoney(total)}</Paragraph>
          <Paragraph dim>Cantidad: {quantity}</Paragraph>
        </div>
      </div>
    </div>
  )
}
